import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getPriceRange(medianPrice: number = 0) {
  if (medianPrice < 30000) {
    return "$"
  }

  if (medianPrice < 100000) {
    return "$$"
  }

  return "$$$"
}

// Check if the formatCurrency function is already defined
// This function formats currency in VND
export const formatCurrency = (amount: number | null | undefined) => {
  if (amount == null) return "N/A"
  return amount.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
  })
}

export function getPlaceHolderDishImage() {
  return "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAGAAQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIDBEH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AoNuqp2uV5TQACT//2Q=="
}

export function formatRatingCount(ratingCount: number) {
  // Format like this
  // 12 => 10+
  // 32 => 30+
  // 123 => 100+
  // 234 => 200+
  // 1234 => 1000+
  // 12345 => 10000+
  // 123456 => 100000+
  // 1234567 => 1000000+
  // 12345678 => 10000000+
  // 123456789 => 100000000+

  if (ratingCount <= 0) return "0"

  // Convert to string to get the length (number of digits)
  const numStr = Math.floor(ratingCount).toString()
  const numDigits = numStr.length

  // Get the first digit
  const firstDigit = parseInt(numStr[0])

  // Calculate the base (10^(numDigits-1))
  const base = Math.pow(10, numDigits - 1)

  // Multiply the first digit by the base
  const result = firstDigit * base

  return `${result}+`
}
